<div class="codec-popup">
  <header class="main-header">
    {{ (!!codec.id ? "EDIT" : "ADD") + " CODEC" }}
  </header>
  <div
    class="codec-name"
    #codecNameDiv
    [attr.contenteditable]="false"
    [textContent]="codec.name"
    (keypress)="($event.keyCode !== 13)"
    (blur)="onCodecEditModeExit($any($event.target).textContent)"
    (keyup.enter)="onCodecEditModeExit($any($event.target).textContent)"
  ></div>
  <span class="change-button" *ngIf="!onCodecEdit" (click)="onChangeClick()"
    >(change)</span
  >
  <section>
    <header>VIDEO:</header>

    <div class="codec-settings">
      <div class="label">CODEC:</div>
      <icn-dropdown
        [short]="true"
        [(selectedValue)]="codec.video.codecType"
        (selectedItemChange)="onVideoCodecChange($event)"
      >
        <icn-dropdown-item
          *ngFor="let videoCodec of formatDetails.video"
          [title]="videoCodec.name.toUpperCase()"
          [value]="videoCodec.value"
          [item]="videoCodec"
        >
        </icn-dropdown-item>
      </icn-dropdown>
    </div>

    <div class="codec-settings resolution-field">
      <div class="label">RESOLUTION:</div>
      <icn-dropdown
        [large]="true"
        [(selectedValue)]="selectedResolutionPreset"
        [equalFunc]="resolutionEqualFunc"
        (selectedValueChange)="onResolutionPresetChanged($event)"
      >
        <icn-dropdown-item
          *ngFor="let videoResolution of selectedVideoCodec.resolutions"
          [title]="videoResolution.presetName"
          [value]="videoResolution"
        ></icn-dropdown-item>
        <icn-dropdown-item
          [title]="DEFAULT_RESOLUTION_PRESET.presetName"
          [isDefault]="true"
          [value]="DEFAULT_RESOLUTION_PRESET"
          [item]="DEFAULT_RESOLUTION_PRESET"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>
    <div class="codec-settings">
      <icn-number-input
        [minLength]="0"
        [maxLength]="8000"
        [(value)]="codec.video.resolution.width"
        [step]="2"
        [useDefaultHtmlInput]="true"
        [allowOnlyButtonUpdates]="true"
        (valueChange)="onResolutionValueChanged()"
      ></icn-number-input>
    </div>
    <span style="margin-left: -13px; display: inline-block">x</span>
    <div class="codec-settings">
      <icn-number-input
        [minLength]="0"
        [maxLength]="8000"
        [(value)]="codec.video.resolution.height"
        [step]="2"
        [useDefaultHtmlInput]="true"
        [allowOnlyButtonUpdates]="true"
        (valueChange)="onResolutionValueChanged()"
      ></icn-number-input>
    </div>

    <div class="codec-settings">
      <div class="label">FPS:</div>
      <icn-dropdown [short]="true" [(selectedValue)]="codec.video.fps">
        <icn-dropdown-item
          *ngFor="let fps of selectedVideoCodec.fps"
          [title]="fps + ''"
          [value]="fps"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>

    <div class="codec-settings">
      <div class="label">BITRATE:</div>
      <input type="number" [(ngModel)]="codec.video.bitrate" />
      <span>Kbits/s</span>
    </div>
  </section>
  <section *ngIf="selectedVideoCodec.profiles.length > 0">
    <div class="profile field">
      <div class="label">PROFILE:</div>
      <div class="profile-select-dropdown">
        <icn-dropdown
          [defaultValue]="0"
          [(selectedValue)]="codec.video.profile"
          [medium]="true"
        >
          <icn-dropdown-item
            *ngFor="let profile of selectedVideoCodec.profiles"
            [title]="profile.name"
            [value]="profile.id"
          ></icn-dropdown-item>
        </icn-dropdown>
        <span>ms</span>
      </div>
    </div>
    <div class="colour-space field">
      <div class="label">COLOUR SPACE:</div>
      <div class="colour-space-select-dropdown">
        <icn-dropdown
          [defaultValue]="0"
          [(selectedValue)]="codec.video.colourSpace"
          [large]="true"
        >
          <icn-dropdown-item
            [title]="'DEFAULT'"
            [value]="0"
          ></icn-dropdown-item>
          <icn-dropdown-item [title]="'BT709'" [value]="1"></icn-dropdown-item>
          <icn-dropdown-item
            [title]="'BT470BG'"
            [value]="2"
          ></icn-dropdown-item>
          <icn-dropdown-item
            [title]="'SMPTE170M'"
            [value]="3"
          ></icn-dropdown-item>
          <icn-dropdown-item
            [title]="'BT2020_NCL'"
            [value]="4"
          ></icn-dropdown-item>
          <icn-dropdown-item
            [title]="'BT2020_CL'"
            [value]="5"
          ></icn-dropdown-item>
        </icn-dropdown>
      </div>
    </div>

    <div class="colour-range field">
      <evrideo-checkbox
        [(active)]="codec.video.mpegColourRange"
      ></evrideo-checkbox>
      <div
        class="label"
        (click)="codec.video.mpegColourRange = !codec.video.mpegColourRange"
      >
        MPEG COLOUR RANGE
      </div>
    </div>
  </section>

  <section>
    <div class="codec-settings">
      <div class="label">KEYFRAME EVERY (GOP SIZE):</div>
      <div>
        <input type="text" [(ngModel)]="codec.video.gopSize" />
        <span>Frames</span>
      </div>
    </div>

    <div
      *ngIf="selectedVideoCodec.progressives.length > 0"
      class="codec-settings"
    >
      <div class="label">INTERLACE/PROGRESSIVE:</div>
      <icn-dropdown [(selectedValue)]="codec.video.interlaceType" [medium]="true">
        <icn-dropdown-item
          *ngFor="let videoProgressive of selectedVideoCodec.progressives"
          [title]="videoProgressive.name"
          [value]="videoProgressive.id"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>

    <div class="codec-settings">
      <div class="label">MUX OVERHEAD:</div>
      <div>
        <input
          type="number"
          min="1"
          max="25"
          step="1"
          [(ngModel)]="codec.video.muxOverhead"
        />
        <span>%</span>
      </div>
    </div>
  </section>
  <section class="special-options">
    <div class="label">Special Options</div>
    <input type="text" [(ngModel)]="codec.video.specialOptions" />
  </section>
  <section>
    <header>AUDIO:</header>

    <div class="codec-settings">
      <div class="label">CODEC:</div>
      <icn-dropdown
        [(selectedValue)]="codec.audio.codecType"
        (selectedItemChange)="onAudioCodecChange($event)"
      >
        <icn-dropdown-item
          *ngFor="let audio of formatDetails.audio"
          [title]="audio.name.toUpperCase()"
          [value]="audio.value"
          [item]="audio"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>

    <div class="codec-settings">
      <div class="label">CHANNELS:</div>
        <icn-dropdown
          [defaultValue]="1"
          [medium]="true"
          [(selectedValue)]="codec.audio.channels"
        >
        <icn-dropdown-item
          *ngFor="let channelConfig of selectedAudioCodec.channels"
          [title]="channelConfig.name"
          [value]="channelConfig.channels"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>

    <div class="codec-settings">
      <div class="label">SAMPLE RATE:</div>
      <icn-dropdown
        [medium]="true"
        [(selectedValue)]="codec.audio.samplerate"
      >
        <icn-dropdown-item
          *ngFor="let sampleRate of selectedAudioCodec.sampleRate"
          [title]="sampleRate + ''"
          [value]="sampleRate"
        ></icn-dropdown-item>
      </icn-dropdown>
    </div>

    <div class="codec-settings">
      <div class="label">AUTO BITRATE:</div>
      <icn-dropdown [medium]="true" [(selectedValue)]="codec.audio.bitrate">
        <icn-dropdown-item
          *ngFor="let biteRate of selectedAudioCodec.bitRate"
          [title]="biteRate + ''"
          [value]="biteRate"
        ></icn-dropdown-item>
      </icn-dropdown>
      <span>Kbits/s</span>
    </div>
  </section>
  <section class="special-options">
    <div class="label">Special Options</div>
    <input type="text" [(ngModel)]="codec.audio.specialOptions" />
  </section>
  <div
    class="x-sign"
    inlineSVG="/assets/icons/x-close-pop.svg"
    (click)="close.emit()"
  ></div>
  <div class="popup-footer">
    <div class="save-btn" [class.disabled]="codec.isDefault" (click)="onSave()">
      SAVE
    </div>
  </div>
</div>
